import React from 'react'
import { useNavigate, useLocation } from 'react-router-dom'
import { 
  FaUserPlus,
  FaUsers,
  FaFolderPlus,
  FaFolder,
  FaSignOutAlt,
  FaHome
} from 'react-icons/fa'
import '../styles/Sidebar.css'

const Sidebar = () => {
  const navigate = useNavigate()
  const location = useLocation()

  // Get user data from localStorage
  const userData = JSON.parse(localStorage.getItem('user'));
  const permissions = userData?.permissions || [];

  // Define menu items with their required permissions based on schema
  const menuItems = [
    { 
      name: 'Dashboard', 
      icon: <FaHome />, 
      path: '/dashboard',
      permission: null // Everyone can access dashboard
    },
    { 
      name: 'Add User', 
      icon: <FaUserPlus />, 
      path: '/add-user',
      permission: 'manage_users'
    },
    { 
      name: 'Users', 
      icon: <FaUsers />, 
      path: '/users',
      permission: 'manage_users'
    },
    { 
      name: 'Add Case', 
      icon: <FaFolderPlus />, 
      path: '/add-case',
      permission: 'add_cases'
    },
    { 
      name: 'Cases', 
      icon: <FaFolder />, 
      path: '/cases',
      permission: 'view_cases'
    }
  ];

  // Filter menu items based on user permissions
  const filteredMenuItems = menuItems.filter(item => {
    // If no permission required, show the item
    if (!item.permission) return true;
    // Otherwise check if user has the required permission
    return permissions.includes(item.permission);
  });

  const handleLogout = () => {
    localStorage.removeItem('user');
    navigate('/login');
  };

  return (
    <div className="sidebar">
      <div className="sidebar-header">
        <h3>Case Management</h3>
        <div className="user-info">
          <span>{userData?.name}</span>
          <small>{userData?.role}</small>
          <div className="user-permissions">
            {permissions.map((permission, index) => (
              <span key={index} className="permission-tag">
                {permission.replace('_', ' ')}
              </span>
            ))}
          </div>
        </div>
      </div>
      <div className="sidebar-menu">
        {filteredMenuItems.map((item, index) => (
          <div
            key={index}
            className={`menu-item ${location.pathname === item.path ? 'active' : ''}`}
            onClick={() => navigate(item.path)}
          >
            <span className="menu-icon">{item.icon}</span>
            <span className="menu-text">{item.name}</span>
          </div>
        ))}
        <div className="menu-item logout" onClick={handleLogout}>
          <span className="menu-icon"><FaSignOutAlt /></span>
          <span className="menu-text">Logout</span>
        </div>
      </div>
    </div>
  )
}

export default Sidebar

